module.exports = __webpack_public_path__ + "img/tur.ed6d5f37.svg";